import { apiCall, API } from '../../utils/APIFunctions';
import KPConfig from '../../KPConfig.js';

export function createFloorPlanFolder(params) {
  let data = new FormData();
  for (let i = 0; i < params.images.length; i++) {
    data.append('files[]', params.images[i]);
  }
  for (let i = 0; i < params.images.length; i++) {
    data.append("floorPlanParams[]", JSON.stringify(params.floorPlanParams[i]));
  }
  data.append("title", params.title);
  data.append("parentId", params.parentId);

  return apiCall(`${API}/floor_plan_folders`, "post", data);
}

export function addFloorPlanPages(params) {
  let data = new FormData();
  for (let i = 0; i < params.images.length; i++) {
    data.append('files[]', params.images[i]);
  }
  for (let i = 0; i < params.images.length; i++) {
    data.append("floorPlanParams[]", JSON.stringify(params.floorPlanParams[i]));
  }
  data.append("parentId", params.parentId);

  return apiCall(`${API}/floor_plan_folders/pages`, "post", data);
}

export function updateFloorPlanImage(params) {
  let data = new FormData();
  data.append('file', params.images[0]);

  return apiCall(`${API}/o/floor_plans/${params.id}/images`, "post", data);
}

export function getFloorPlan(id) {
  return apiCall(`${API}/floor_plans/${id}`, "GET");
}

export function getFloorPlanPages(id) {
  return apiCall(`${API}/floor_plans/${id}/pages?returnSinglePage=1`, "GET");
}

export async function getFloorPlanStatusId(floorPlanId, type, markingFilters) {
  const params = new URLSearchParams({
    async: true,
    type,
    markingFilters: JSON.stringify(markingFilters)
  });

  const controller = new AbortController();
  const timeout = 30000;
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => {
      controller.abort();
      reject(new Error("API call timed out after 30 seconds"));
    }, timeout);
  });

  try {
    const apiCallPromise = apiCall(
      `${KPConfig.backendUrl}/pdf/floor_plans/${floorPlanId}.pdf?${params}`,
      "get",
      null,
      controller.signal
    );

    const result = await Promise.race([apiCallPromise, timeoutPromise]);
    return result;
  } catch (error) {
    if (error.message === "Request aborted") {
      console.error("API call timed out after 30 seconds");
    } else {
      console.error(error.message);
    }
    throw error;
  }
}

export function savePrintSettings(floorPlanId, printSettings) {
  return apiCall(`${API}/floor_plans/${floorPlanId}/print_settings`, "put", JSON.stringify(printSettings));
}

export function rotateImage(objectId, params) {
  return apiCall(`${API}/o/floor_plans/${objectId}/images/rotate`, "put", JSON.stringify(params));
}

export function createPartyFolder(data) {
  return apiCall(`${API}/floor_plans/partyfolders`, "post", JSON.stringify(data));
}

export function saveDrawSettings(floorPlanId, data) {
  return apiCall(`${API}/floor_plans/${floorPlanId}/draw_settings`, "put", JSON.stringify(data));
}